import { render } from "./CollectInfoForm.vue?vue&type=template&id=52caa073&scoped=true&ts=true"
import script from "./CollectInfoForm.vue?vue&type=script&lang=ts"
export * from "./CollectInfoForm.vue?vue&type=script&lang=ts"

import "./CollectInfoForm.vue?vue&type=style&index=0&id=52caa073&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52caa073"]])

export default __exports__